var AppTracking = Object.freeze({
  getPermissionStatus: function getPermissionStatus() {
    return "denied";
  },
  requestPermission: function requestPermission() {
    return Promise.resolve("denied");
  }
});
export {
  AppTracking
};
//# sourceMappingURL=unavailable.js.map
